
































































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store/store';
import Auth from '@/store/modules/auth';
import { db } from '@/plugins/firebase';
import { levelTable } from '@/plugins/levelTable';
import { User } from 'firebase';
import UserName from '@/components/atoms/UserName.vue';
const authModule = getModule(Auth, store);

@Component({
  firestore: {
    users: db
      .collection('users')
      .orderBy('charCount', 'desc')
      .limit(100),
    progress: db
      .collection('dailyProgress')
      .orderBy('timestamp', 'desc')
      .limit(2),
  },
  components: {
    UserName
  }
})
export default class LeaderBoard extends Vue {
  users: User[] = [];
  progress = [];

  get latestProgress() {
    return this.progress[0];
  }

  get charCountIncrease() {
    return this.progress[0].charCount - this.progress[1].charCount;
  }

  get completedImageIncrease() {
    return (
      this.progress[0].completedImageCount -
      this.progress[1].completedImageCount
    );
  }
}
